import React from 'react';

function FactsTable({ title, rows }: { title: string, rows: FactsTableRow[] }) {

    const lastIndex = rows.length - 1;

    const elements = rows.map((row, index) => {

        const css = [
            index !== lastIndex ? 'border-b border-gray-300' : '',
            getRowTextStyle(row),
        ].join(' ');

        return <div key={index} className={'flex py-1 ' + css}>
                <span className={'flex'}>{row.title}</span>
                <span className={'flex ml-auto'}>{row.value}</span>
            </div>;

    });

    return <div className={'px-4 py-2 rounded-lg bg-gray-200 text-gray-800'}>
        <div className={'text-xl text-left my-2'}>{title}</div>
        {elements}
    </div>

}

export enum FactsTableRowType {
    ROW,
    SMALL,
    TOTAL,
}

function getRowTextStyle(row: FactsTableRow) {

    switch (row.type) {
        case FactsTableRowType.TOTAL:
            return 'font-semibold';
        case FactsTableRowType.SMALL:
            return 'text-sm';
        default:
            return '';
    }

}


export interface FactsTableRow {
    title?: string,
    value?: string
    type?: FactsTableRowType
}

export default FactsTable;